import { render, staticRenderFns } from "./CargoVolumeCmp.vue?vue&type=template&id=211323d4&"
import script from "./CargoVolumeCmp.vue?vue&type=script&lang=js&"
export * from "./CargoVolumeCmp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports